import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';


import { DocumentsService } from './../../services/documents/documents.service';
import { DepartamentService } from './../../services/departaments/departament.service';


@Component({
  selector: 'app-libraries',
  templateUrl: './libraries.component.html',
  styleUrls: ['./libraries.component.scss']
})
export class LibrariesComponent implements OnInit {

  documents:any[];
  categories:any[];
  departaments:any[];
  departamentSelected = null;
  categorySelected = null;
  municipalityselected = null;

  public filter: any = { title : ''};
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = false;
  public config = {
    id: 'pagination',
    itemsPerPage: 6,
    currentPage: 0
  };
  public labels: any = {
    previousLabel: 'Anterior',
    nextLabel: 'Siguiente',
    screenReaderPaginationLabel: 'Paginaión',
    screenReaderPageLabel: 'Pagina',
    screenReaderCurrentLabel: `Te encuentras aqui`
  };

  constructor(
    private documentsServices:DocumentsService,
    private departamentService:DepartamentService
  ) { }

  ngOnInit() {
    this.getDocuments();
    this.getCategories();
    this.getDepartments();
  }

  getDocuments(){
    this.documentsServices.getDocuments()
    .subscribe(documents => {

      let temporaly = [];

      documents.forEach(doc => {
        doc.title = doc.name;
        doc.date2 = doc.publicationDate;

        // delete doc.publicationDate;
        // delete doc.name;


        temporaly.push(doc);
      })

      this.documents = temporaly;


      // this.documents = documents;
    })
  }

  getCategories(){
    this.documentsServices.getCategories().subscribe(categories => {
      // console.log(categories)
      this.categories = categories;
    })
  }

  getDepartments(){

    this.departamentService.getDepartaments().subscribe(departaments => {
      this.departaments = departaments;
    })

  }

  search(){

    if (
      this.departamentSelected == null &&
      this.municipalityselected == null &&
      this.categorySelected == null
    ) {
      this.getDocuments()
    }else{
       let keyword = (this.filter.title == '') ? null : this.filter.title;

      this.documentsServices.search(
        this.departamentSelected,this.municipalityselected,this.categorySelected,keyword
      ).subscribe(documents => {

        if (documents == null) {
          this.documents = []
        }else{
          documents.forEach(doc => {
            doc.title = doc.name;
            doc.date2 = doc.publicationDate;

            delete doc.publicationDate;
            delete doc.name;
          })

          this.documents = documents;
        }


      })
    }


  }

  onPageChange(number: number) {
    console.log('change to page', number);
    this.config.currentPage = number;
  }

}
